import { ModuleConfig } from '@core/interfaces';

const config: ModuleConfig = {
  name: 'Busk',
  baseUrl: '',
  routes: [
    {
      path: '/admin/busk/sellers',
      page: 'BuskSeller',
      title: 'Busk Admin seller',
      exact: true
    },
    {
      path: '/admin/busk/sellers/:id',
      page: 'BuskSellerDetail',
      title: 'Busk Admin busk',
      exact: true
    },
    {
      path: '/admin/busk/logistic',
      page: 'BuskWarehouse',
      title: 'Busk Admin warehouse',
      exact: true
    },
    {
      path: '/admin/busk/stock',
      page: 'BuskStock',
      title: 'Busk Admin warehouse',
      exact: true
    },
    {
      path: '/admin/busk/stock/:id',
      page: 'BuskStockDetail',
      title: 'Busk Admin stock',
      exact: true
    },
    {
      path: '/admin/busk/logistic/:id',
      page: 'BuskWarehouseDetail',
      title: 'Busk Admin busk',
      exact: true
    },
    {
      path: '/admin/busk/',
      page: 'BuskAdminDashboard',
      title: 'Busk Admin busk',
      exact: true
    },
    {
      path: '/admin/busk/forwarding',
      page: 'BuskForwarding',
      title: 'Busk Admin Forwarding',
      exact: true
    }
  ],
  requireAuthenticated: true
};

export default config;
